import type { NewsItem } from "@/types";

export const newsList: NewsItem[] = [
  {
    id: "news-01",
    title: "风间由美亮相第38届亚洲电影节，主演新片《雾港》全球首映",
    summary:
      "风间由美携主演电影《雾港》出席第38届亚洲电影节红毯与全球首映礼，现场分享拍摄心路，影片收获全场长时间掌声。",
    content: [
      "当地时间本周五晚，第38届亚洲电影节在滨海艺术中心拉开帷幕。风间由美一身深色缎面礼服亮相红毯，与《雾港》导演及主创团队一同出席影片的全球首映礼。",
      "《雾港》讲述一名在港口城市寻找失踪亲人的女性，在潮湿浓雾中逐渐揭开真相的故事。风间由美在片中承担了大量水下与夜戏实拍，她表示这是自己从影以来体能和心理挑战最大的一次。",
      "首映结束后，现场观众报以长达数分钟的掌声。多家国际媒体在映后评价中称其表演“克制而富有层次”。影片预计于年底在多个地区陆续上映。",
    ],
    date: "2026-10-09",
    category: "活动现场",
    author: "风间由美工作室",
    source: "官方资讯",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20red%20carpet%20film%20festival%20entrance%20at%20night%20with%20warm%20amber%20spotlights%2C%20elegant%20dark%20curtain%20backdrop%2C%20abstract%20artistic%20photography%2C%20soft%20glow%2C%20harmonious%20warm%20orange%20tone%2C%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=news-film-festival&orientation=landscape",
    tags: ["电影节", "雾港", "首映"],
    featured: true,
  },
  {
    id: "news-02",
    title: "风间由美全新单曲《未寄出的信》上线，首日空降榜单前三",
    summary:
      "由风间由美亲自参与作词的单曲《未寄出的信》正式发行，上线首日即进入主流音乐平台新歌榜前三。",
    content: [
      "单曲《未寄出的信》于今日零点在全平台上线。这是一首以钢琴与弦乐为底色的抒情作品，歌词取材于风间由美多年来的手写日记。",
      "她谈到创作初衷时说：“有些话当时没能说出口，多年以后写下来，反而更诚实。”编曲上刻意保留了呼吸声与翻页的细碎声响，营造私密感。",
      "歌曲上线十二小时内进入多个平台新歌榜前三，MV将后续发布。",
    ],
    date: "2026-10-05",
    category: "音乐",
    author: "风间由美工作室",
    source: "官方资讯",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20analog%20music%20studio%20scene%20with%20sheet%20paper%20and%20vintage%20microphone%2C%20soft%20golden%20window%20light%2C%20abstract%20minimal%20artistic%20photography%2C%20muted%20orange%20and%20cream%20palette%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=news-single-letter&orientation=landscape",
    tags: ["新歌", "音乐"],
    featured: true,
  },
  {
    id: "news-03",
    title: "风间由美确认加盟悬疑剧《长夜将明》，挑战高难度双面角色",
    summary:
      "官方正式官宣风间由美出演悬疑剧《长夜将明》女主角，将一人分饰性格迥异的双胞胎姐妹。",
    content: [
      "《长夜将明》由实力编剧团队打造，故事围绕一桩跨越十年的旧案展开。风间由美将在剧中分饰双胞胎姐妹，两人性格与命运走向截然不同。",
      "为准备角色，她提前两个月参与方言与形体训练，并反复阅读真实案件资料。她说：“我希望观众忘记是同一个人演的。”",
      "该剧计划于明年第二季度开机，具体上线时间待定。",
    ],
    date: "2026-09-28",
    category: "影视动态",
    author: "风间由美工作室",
    source: "官方资讯",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20street%20at%20dusk%20with%20warm%20streetlights%20and%20long%20shadows%2C%20abstract%20suspense%20atmosphere%2C%20deep%20orange%20and%20charcoal%20tones%2C%20artistic%20photography%2C%20soft%20mist%2C%20high%20detail%20composition&width=800&height=600&seq=news-long-night&orientation=landscape",
    tags: ["电视剧", "长夜将明"],
    featured: true,
  },
  {
    id: "news-04",
    title: "官方公告：风间由美2026巡回见面会首批城市公布",
    summary:
      "风间由美2026巡回见面会首批公布六座城市，门票将采用实名制预约，具体开票时间另行通知。",
    content: [
      "感谢大家一直以来的支持。风间由美2026巡回见面会首批城市正式公布，分别为：北京、上海、广州、成都、杭州、武汉。",
      "本次巡演将采用实名制预约抽签方式，力求让更多粉丝有机会到场。具体开票时间、场次与入场规则将在后续公告中说明。",
      "请各位粉丝以官方渠道信息为准，谨防来源不明的售票信息。",
    ],
    date: "2026-09-20",
    category: "官方公告",
    author: "风间由美工作室",
    source: "官方公告",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stage%20with%20warm%20amber%20spotlights%20and%20soft%20light%20beams%2C%20empty%20concert%20platform%2C%20artistic%20minimal%20photography%2C%20orange%20and%20warm%20neutral%20palette%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=600&seq=news-tour-announce&orientation=landscape",
    tags: ["巡演", "公告"],
    featured: false,
  },
  {
    id: "news-05",
    title: "风间由美登上《光影》杂志封面，畅谈表演与成长",
    summary:
      "风间由美成为《光影》杂志十月刊封面人物，在深度专访中回顾十年表演生涯与心态变化。",
    content: [
      "在《光影》杂志十月刊的封面专访中，风间由美罕见地谈到了自己刚入行时的迷茫与不安。",
      "“我曾经很害怕被定型，后来发现真正要战胜的是自己对角色的懒惰。”她这样总结自己的十年。",
      "本期杂志还收录了一组自然光下的黑白人物写真，随刊发行。",
    ],
    date: "2026-09-14",
    category: "杂志写真",
    author: "风间由美工作室",
    source: "《光影》杂志",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20editorial%20photo%20shoot%20set%20with%20soft%20cream%20backdrop%2C%20warm%20diffused%20studio%20lighting%2C%20abstract%20fashion%20still%20life%20with%20fabric%20drape%2C%20refined%20orange%20and%20beige%20palette%2C%20high%20detail%2C%20artistic%20composition&width=800&height=600&seq=news-magazine-cover&orientation=landscape",
    tags: ["杂志", "专访"],
    featured: false,
  },
  {
    id: "news-06",
    title: "幕后花絮：《雾港》拍摄特辑公开，风间由美亲述潜水戏挑战",
    summary:
      "官方发布《雾港》拍摄幕后特辑，揭秘水下摄影与长时间夜戏的真实拍摄过程。",
    content: [
      "《雾港》幕后特辑今日上线。视频记录了风间由美在水下摄影棚中的拍摄过程，包括闭气训练与安全团队的严密保障。",
      "为呈现真实的窒息感，她坚持在可控范围内亲自完成大部分水下镜头，单条镜头最长拍摄近五分钟。",
      "导演评价：“她把恐惧交给了身体，而不是表情。”特辑完整版可在官方频道观看。",
    ],
    date: "2026-09-06",
    category: "影视动态",
    author: "风间由美工作室",
    source: "官方资讯",
    image:
      "https://readdy.ai/api/search-image?query=Underwater%20photography%20set%20with%20soft%20light%20rays%20and%20rising%20bubbles%2C%20abstract%20teal%20and%20warm%20amber%20light%20mix%2C%20artistic%20cinematic%20photography%2C%20dreamy%20atmosphere%2C%20high%20detail%20composition&width=800&height=600&seq=news-water-behind&orientation=landscape",
    tags: ["幕后", "雾港"],
    featured: false,
  },
  {
    id: "news-07",
    title: "风间由美公益行动：为乡村儿童图书室捐建计划启动",
    summary:
      "风间由美联合公益机构发起“一页光”图书室捐建计划，首期为十二所乡村学校添置图书与阅读角。",
    content: [
      "“一页光”计划正式启动。首批将为十二所乡村学校捐建图书室，包含适龄读物、书架与阅读照明设备。",
      "风间由美在启动仪式上说：“我小时候最大的幸运，是在图书室里第一次读到了外面的世界。”",
      "该项目将公开物资流向，欢迎公众一起参与监督与支持。",
    ],
    date: "2026-08-30",
    category: "公益",
    author: "风间由美工作室",
    source: "官方公告",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20sunlit%20reading%20room%20with%20wooden%20shelves%20full%20of%20books%2C%20warm%20natural%20light%20through%20large%20window%2C%20soft%20orange%20and%20cream%20palette%2C%20artistic%20editorial%20photography%2C%20high%20detail%2C%20calm%20atmosphere&width=800&height=600&seq=news-charity-library&orientation=landscape",
    tags: ["公益", "阅读"],
    featured: false,
  },
  {
    id: "news-08",
    title: "风间由美获年度最佳女演员提名，粉丝应援活动同步开启",
    summary:
      "风间由美凭《山与海之间》获得年度最佳女演员提名，官方粉丝应援活动同步开启。",
    content: [
      "年度影视盛典提名名单公布，风间由美凭《山与海之间》入围最佳女演员。",
      "官方同步开启应援活动，粉丝可在指定页面留下对作品的感受与祝福，优质留言将在应援影像中呈现。",
      "风间由美工作室表示：“每一次被看见，都离不开台前台后的每一个人。”",
    ],
    date: "2026-08-21",
    category: "活动现场",
    author: "风间由美工作室",
    source: "官方资讯",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20elegant%20award%20ceremony%20stage%20with%20soft%20gold%20light%20and%20abstract%20bokeh%2C%20artistic%20minimal%20photography%2C%20orange%20and%20champagne%20palette%2C%20cinematic%20atmosphere%2C%20high%20detail%20composition&width=800&height=600&seq=news-award-nominee&orientation=landscape",
    tags: ["提名", "应援"],
    featured: false,
  },
  {
    id: "news-09",
    title: "纪录片《回声之地》定档，风间由美担任旁白配音",
    summary:
      "自然人文纪录片《回声之地》正式定档，由风间由美担任全片旁白配音。",
    content: [
      "《回声之地》以三条河流为线索，记录沿岸普通人的生活与迁徙。风间由美受邀担任旁白配音。",
      "她说录制过程中最难的是“学会安静”，让声音成为画面的背景而不是主角。",
      "影片将于下月上线，配音花絮将陆续公开。",
    ],
    date: "2026-08-12",
    category: "影视动态",
    author: "风间由美工作室",
    source: "官方资讯",
    image:
      "https://readdy.ai/api/search-image?query=Serene%20river%20landscape%20at%20golden%20hour%20with%20soft%20mist%20over%20water%2C%20abstract%20natural%20documentary%20aesthetic%2C%20warm%20orange%20and%20sage%20tones%2C%20artistic%20photography%2C%20high%20detail%2C%20tranquil%20mood&width=800&height=600&seq=news-documentary-echo&orientation=landscape",
    tags: ["纪录片", "配音"],
    featured: false,
  },
  {
    id: "news-10",
    title: "风间由美工作室发布年度影像日记，记录三十六个瞬间",
    summary:
      "工作室发布年度影像日记短片，以三十六个生活化瞬间回顾过去一年台前幕后的日常。",
    content: [
      "没有红毯，也没有聚光灯。年度影像日记收录了化妆间、排练场、清晨的厨房与深夜的剧本会。",
      "风间由美在片尾写道：“这些看起来不起眼的日子，才是我真正的生活。”",
      "短片在官方频道上线后，短时间内获得大量转发。",
    ],
    date: "2026-08-03",
    category: "官方公告",
    author: "风间由美工作室",
    source: "官方资讯",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20morning%20kitchen%20with%20warm%20sunlight%20and%20soft%20film%20grain%2C%20abstract%20lifestyle%20still%20life%20photography%2C%20cream%20and%20amber%20palette%2C%20artistic%20composition%2C%20high%20detail%2C%20intimate%20atmosphere&width=800&height=600&seq=news-video-diary&orientation=landscape",
    tags: ["影像", "日常"],
    featured: false,
  },
  {
    id: "news-11",
    title: "风间由美合作音乐人林澈，新EP《潮汐备忘录》预告释出",
    summary:
      "风间由美与音乐人林澈合作的EP《潮汐备忘录》释出预告，五首作品围绕“潮汐”意象展开。",
    content: [
      "EP《潮汐备忘录》包含五首作品，由风间由美与林澈共同制作，融合民谣与氛围电子。",
      "概念围绕潮汐的涨落，隐喻人与人之间靠近与远离的节奏。首支单曲将随预告后续发布。",
      "预告片的画面由风间由美亲自参与分镜设计。",
    ],
    date: "2026-07-25",
    category: "音乐",
    author: "风间由美工作室",
    source: "官方资讯",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20ocean%20waves%20at%20sunset%20with%20warm%20orange%20reflections%20on%20water%2C%20artistic%20minimal%20photography%2C%20soft%20gradient%20sky%2C%20dreamy%20atmosphere%2C%20high%20detail%20cinematic%20composition&width=800&height=600&seq=news-ep-tide&orientation=landscape",
    tags: ["音乐", "EP"],
    featured: false,
  },
  {
    id: "news-12",
    title: "风间由美出席品牌发布会，演绎秋冬全新系列大片",
    summary:
      "风间由美以品牌代言人身份出席秋冬系列发布会，全新广告大片同步上线。",
    content: [
      "作为品牌长期合作伙伴，风间由美出席秋冬系列发布会，并演绎全新广告大片。",
      "本次大片以“暖冬光线”为主题，在自然光下完成拍摄，强调质感与日常感。",
      "相关单品将于发布会后陆续上架。",
    ],
    date: "2026-07-16",
    category: "活动现场",
    author: "风间由美工作室",
    source: "官方资讯",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20fashion%20brand%20showroom%20with%20warm%20ambient%20lighting%20and%20cream%20textile%20displays%2C%20abstract%20editorial%20photography%2C%20refined%20orange%20and%20beige%20palette%2C%20high%20detail%2C%20sophisticated%20atmosphere&width=800&height=600&seq=news-brand-show&orientation=landscape",
    tags: ["品牌", "代言"],
    featured: false,
  },
  {
    id: "news-13",
    title: "粉丝专属：风间由美生日应援影像征集活动开启",
    summary:
      "一年一度的生日应援影像征集正式开启，入选作品将合成为官方应援短片。",
    content: [
      "生日应援影像征集正式开始。粉丝可提交照片、绘画或短片，主题为“我们想一起看见的光”。",
      "入选作品将被剪辑为官方应援短片，在生日当天于官方渠道发布。",
      "投稿需为原创内容，并授权官方公益范围内使用。",
    ],
    date: "2026-07-08",
    category: "官方公告",
    author: "风间由美工作室",
    source: "官方公告",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20celebration%20scene%20with%20soft%20string%20lights%20bokeh%20and%20candles%2C%20abstract%20festive%20minimal%20photography%2C%20amber%20and%20cream%20palette%2C%20dreamy%20atmosphere%2C%20high%20detail%20composition&width=800&height=600&seq=news-birthday-collect&orientation=landscape",
    tags: ["应援", "粉丝"],
    featured: false,
  },
  {
    id: "news-14",
    title: "风间由美谈新作《长夜将明》：想把恐惧演得真实",
    summary:
      "在一场小范围媒体交流中，风间由美分享了出演《长夜将明》的准备过程与表演思考。",
    content: [
      "“恐惧不是大喊大叫，而是你明明很害怕，却还要假装没事。”风间由美如此描述她对新角色的理解。",
      "她透露自己为角色建立了一本厚厚的“人物档案”，包括童年经历、习惯动作与说话节奏。",
      "被问及是否担心题材沉重时，她笑说：“好的故事从来不是为了让人舒服。”",
    ],
    date: "2026-06-30",
    category: "杂志写真",
    author: "风间由美工作室",
    source: "媒体交流",
    image:
      "https://readdy.ai/api/search-image?query=Intimate%20interview%20room%20with%20warm%20table%20lamp%20light%20and%20script%20papers%20on%20desk%2C%20abstract%20minimal%20photography%2C%20amber%20and%20deep%20neutral%20palette%2C%20soft%20shadows%2C%20high%20detail%20atmosphere&width=800&height=600&seq=news-interview-night&orientation=landscape",
    tags: ["专访", "表演"],
    featured: false,
  },
];

export const newsCategories = ["全部", "官方公告", "影视动态", "音乐", "活动现场", "杂志写真", "公益"];